// appsActions.js
import {
  ADD_FAVORITE_APP,
  REMOVE_FAVORITE_APP,
  INIT_FAVORITE_APP
} from '../types/favoriteAppConstants'

export function initFavoriteApp(items) {
  return {
    type: INIT_FAVORITE_APP,
    payload: items
  }
}

export function addFavoriteApp(item) {
  return {
    type: ADD_FAVORITE_APP,
    payload: item
  }
}

export function removeFavoriteApp(item) {
  return {
    type: REMOVE_FAVORITE_APP,
    payload: item
  }
}
